class Popup {
  init() {

    const container = $('.js-popup');

    $(document).on('click', '.js-popup-close', function(e) {
      e.preventDefault();
      $(e.currentTarget).parent().parent().fadeOut(300, function() {
        $(this).remove()
      });
    })

  }
}

export default Popup;